export const GET_TESTIMONIAL_ATTEMPT = 'GET_TESTIMONIAL_ATTEMPT';
export type GET_TESTIMONIAL_ATTEMPT = typeof GET_TESTIMONIAL_ATTEMPT;

export const GET_TESTIMONIAL_SUCCESS = 'GET_TESTIMONIAL_SUCCESS';
export type GET_TESTIMONIAL_SUCCESS = typeof GET_TESTIMONIAL_SUCCESS;

export const GET_TESTIMONIAL_FAILURE = 'GET_TESTIMONIAL_FAILURE';
export type GET_TESTIMONIAL_FAILURE = typeof GET_TESTIMONIAL_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/testimonial/get/Types.tsx